import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';
import ExportErrorResponse from '../../User/ProductGroup/ExportErrorResponse';
import { WrappedExportResponse } from 'com.cogvio.pricemonitor.api';

export type ExportAnalyticsRequest = {
	brandNames: string[];
	atcs: string[];
	filterTherapeuticAreas: string[];
	currency: string | null;
};

export const createAnalyticsExport = async (
	client: ApiClient,
	data: ExportAnalyticsRequest
): Promise<WrappedExportResponse> => {
	try {
		const response = await client.fetch('analytics/export', {
			method: 'POST',
			body: JSON.stringify(data),
		});
		return response.json();
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ExportErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
